import {withGrayTransparency} from "../../../../hocs/withGrayTransparency";
import {withUppercase} from "../../../../hocs/withUppercase";
import {CardItemValue} from "../CardItemValue";

export const CardItemValueWithGrayUppercase = withUppercase(withGrayTransparency(CardItemValue));
